import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EntityData } from '../types';

export const useEntityData = (): EntityData => {
  const metadata = useSelector((state: any) => state.metadata);
  
  const communities = useMemo(() => 
    (metadata?.entities as any)?.community || [], 
    [metadata]
  );
  
  const sites = useMemo(() => 
    (metadata?.entities as any)?.site || [], 
    [metadata]
  );
  
  const members = useMemo(() => 
    (metadata?.entities as any)?.member || [], 
    [metadata]
  );

  const getCommunityById = useCallback((id: string) => {
    return communities.find((community: any) => community?.communityId === id);
  }, [communities]);
  
  const getSiteById = useCallback((id: string) => {
    return sites.find((site: any) => site?.siteId === id);
  }, [sites]);
  
  const getMemberById = useCallback((id: string) => {
    return members.find((member: any) => member?.memberId === id);
  }, [members]);

  const getAllCommunities = useCallback(() => communities, [communities]);
  const getAllSites = useCallback(() => sites, [sites]);
  const getAllMembers = useCallback(() => members, [members]);

  return {
    getCommunityById,
    getSiteById,
    getMemberById,
    getAllCommunities,
    getAllSites,
    getAllMembers
  };
}; 